export default "__VITE_ASSET__DLdp5$Ym__"